import React, { useMemo } from 'react';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { simpleHash } from '@web-mail/util';
import { getIn18Text } from 'api';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import styles from './mailListTips.module.scss';
import Modal from '@lingxi-common-component/sirius-ui/SiriusModal';
import Button from '@lingxi-common-component/sirius-ui/Button';
import useDebounceForEvent from '@web-mail/hooks/useDebounceForEvent';
const MailSearchDeleteTip = props => {
    const dispatch = useAppDispatch();
    const [mailSearching] = useState2RM('mailSearching');
    const layoutIsLR = useAppSelector(state => {
        return state.mailReducer.configMailLayout == '1';
    });
    const isSearching = useMemo(() => !!mailSearching, [mailSearching]);
    const searchBatchDelLoading = useAppSelector(state => {
        try {
            const map = state.mailReducer.batchDeleteLoadingMap;
            const isAdvanceSearch = state.mailReducer.mailSearching == 'advance';
            let hash = '';
            if (isAdvanceSearch) {
                hash = simpleHash(state.mailReducer.advancedSearchParam);
            }
            else {
                hash = simpleHash(state.mailReducer.searchParam);
                if (map['_All_Folder_Delete']) {
                    return true;
                }
            }
            return !!map[hash];
        }
        catch (e) {
            return false;
        }
    });
    const searchListCount = useAppSelector(state => {
        var _a;
        return ((_a = state.mailReducer.searchList) === null || _a === void 0 ? void 0 : _a.length) || 0;
    });
    const searchTotal = useAppSelector(state => { var _a; return ((_a = state.mailReducer.searchResultObj) === null || _a === void 0 ? void 0 : _a.total) || 0; });
    const handleDeleteAll = useDebounceForEvent(() => {
        Modal.warning({
            title: '删除确认',
            content: React.createElement("div", null, getIn18Text('QUEDINGJIANGSUOYOUSSCLDYJDYDDYSCWJJM？')),
            okText: getIn18Text('QUEDING'),
            cancelText: getIn18Text('QUXIAO'),
            closable: true,
            isGlobal: true,
            onOk: () => {
                dispatch(Thunks.deleteAllSearchMail({
                    processCallback: (process) => {
                        console.log(process);
                    },
                    successCallback: () => {
                        console.log('删除完成');
                    },
                    failCallback: () => {
                        console.log('删除失败');
                    },
                    cancelCallback: () => {
                        console.log('任务取消');
                    },
                    getCancelFn: (cb) => {
                        console.log(cb);
                    },
                }));
            },
        });
    });
    return isSearching && !!searchListCount ? (React.createElement("div", { className: `${styles.searchDeleteTip} ${!layoutIsLR ? styles.flat : ''}` },
        React.createElement("div", { className: styles.stpTitle }, getIn18Text('SOUSUOJIEGUO')),
        React.createElement("div", { className: styles.stpContentWrap },
            React.createElement("div", { className: styles.stpTips }, getIn18Text('YISOUSUODAOFENGYJ', { searchTotal: searchTotal || 0 })),
            React.createElement(Button, { "data-test-id": "mail-search-delete-all-btn", className: styles.stpActive, disabled: searchBatchDelLoading, onClick: handleDeleteAll, loading: searchBatchDelLoading, btnType: "link" }, searchBatchDelLoading ? getIn18Text('SHANCHUZHONG...') : getIn18Text('SHANCHUSUOYOU$FYJ', { searchTotal: searchTotal || 0 }))))) : (React.createElement(React.Fragment, null));
};
export default MailSearchDeleteTip;
